// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Факторний аналіз» (Factor analysis, ключ `pfac`, група `analysis`). */
export const factorAnalysisManifest: IModuleManifest = {
  key: 'pfac',
  group: 'analysis',
  slug: 'factor-analysis',
  prefix: 'PFA',
  name: { en: 'Factor analysis', uk: 'Факторний аналіз' },
  entities: [
    { key: 'pfac', slug: 'pfac', name: { en: 'Factors', uk: 'Чинники' }, main: true },
    { key: 'pind', slug: 'pind', name: { en: 'Indicators', uk: 'Показники' }, main: false },
  ],
  loadState: () => import('./state/factorAnalysisSlice').then((m) => m.factorAnalysisSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
  loadViews: () => import('./views').then((m) => m.views),
};
